<template>
    <transition appear name="fade">
        <div class="d-flex flex-column">
            <div class="d-flex justify-content-between">
                <div id="space-filler"></div>
                <appAdminSidebar></appAdminSidebar>
                <appHeader />
            </div>

            <div class="container py-4">
                <h4 class="mb-4">Export Card Details (Doesn't include incentiveweb orders)</h4>

                <div class="row g-3 align-items-end">
                    <div class="col-md-3">
                        <label for="startDate" class="form-label">Start Date</label>
                        <input type="date" id="startDate" v-model="startDate" class="form-control" />
                    </div>

                    <div class="col-md-3">
                        <label for="endDate" class="form-label">End Date</label>
                        <input type="date" id="endDate" v-model="endDate" class="form-control" />
                    </div>

                    <div class="col-md-3">
                        <label for="clientID" class="form-label">Client (*Comma Separated Values*)</label>
                        <input type="text" id="clientID" v-model="clientID" class="form-control"
                            placeholder="Leave empty for all clients" />
                    </div>

                    <div class="col-md-3 d-flex align-items-center">
                        <div class="form-check me-3">
                            <input class="form-check-input" type="checkbox" v-model="includeIWTxn" id="includeIWTxn" />
                            <label class="form-check-label" for="includeIWTxn">Include IncentiveWeb Transactions</label>
                        </div>
                        <!-- <button class="btn btn-primary" @click="exportCardDetails" :disabled="!startDate || !endDate">
                            Export
                        </button> -->
                        <button 
                            class="btn btn-primary" 
                            @click="exportCardDetails" 
                            :disabled="!startDate || !endDate || isExporting"
                        >
                            {{ isExporting ? "Exporting..." : "Export" }}
                        </button>
                    </div>
                </div>

                <appFooter class="mt-5" />
            </div>
        </div>
    </transition>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import GiftcardService from "@/services/GiftcardService";

export default {
    name: "CardCreatedByExport",
    components: {
        appHeader: Header,
        appFooter: Footer,
        appAdminSidebar: AdminSidebar,
    },
    data() {
        return {
            startDate: "",
            endDate: "",
            clientID: "",
            includeIWTxn: false,
            isExporting: false,
        };
    },
    methods: {
        async exportCardDetails() {
            if (this.isExporting) return;
            console.log("ClientID before request:", this.clientID, typeof this.clientID);

            this.isExporting = true;

            alert("Report is being created and will be downloaded shortly.");

            try {
                const response = await GiftcardService.getCardCreatedByDetails(
                    this.startDate,
                    this.endDate,
                    this.clientID,
                    this.includeIWTxn
                );

                const data = response?.data?.data || [];

                if (!data.length) {
                    alert("No data available for the selected date range.");
                    return;
                }

                const suffix = data[0].client_name
                    ? data[0].client_name.replace(/\s+/g, "_")
                    : "cards_created";

                this.exportToCsv(`card_created_by_${suffix}.csv`, data);
            } catch (error) {
                console.error("Export failed:", error);
                alert("Failed to export card details.");
            } finally {
                this.isExporting = false; // ✅ ALWAYS re-enable
            }
        },
        exportToCsv(filename, rows) {
            if (!rows.length) return;

            const headers = Object.keys(rows[0]);
            const csvContent =
                headers.join(",") +
                "\n" +
                rows
                    .map((row) =>
                        headers
                            .map((h) =>
                                row[h] != null ? `"${String(row[h]).replace(/"/g, '""')}"` : ""
                            )
                            .join(",")
                    )
                    .join("\n");

            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    },
};
</script>

<style scoped>
label {
    font-weight: 500;
}

.g-3>.col-md-3 {
    display: flex;
    flex-direction: column;
}
</style>
